import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";

@Injectable()
export class JwtService {
  constructor(private readonly cookiesService: CookieService) {}

  getIdToken(): string {
    //console.log(window.localStorage['jwtIdToken']);
    return this.cookiesService.get("jwtIdToken");
  }

  setIdToken(idToken: string): void {
    this.cookiesService.set("jwtIdToken", idToken);
  }

  setRToken(rToken: string): void {
    this.cookiesService.set("rToken", rToken);
  }

  getRToken(): string {
    const rToken = this.cookiesService.get("rToken");

    return rToken ? JSON.parse(rToken) : undefined;
  }

  destroyTokens() {
    this.cookiesService.delete("jwtIdToken");
  }

  setTimeToken(tToken: any): void {
    this.cookiesService.set("tToken", JSON.stringify(tToken));
  }

  getTimeToken() {
    const tToken = this.cookiesService.get("tToken");

    return tToken ? JSON.parse(tToken) : undefined;
  }

  isExpiredToken(): boolean {
    const current_time = Date.now() / 1000;
    const tToken = this.getTimeToken();

    if (tToken === undefined || tToken === null) {
      return false;
    }

    const jwt_exp = parseFloat(tToken["exp"]);

    const _date = new Date(0);
    _date.setUTCSeconds(jwt_exp);

    return jwt_exp < current_time ? true : false;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/jwt.service.ts